import { useFela } from 'react-fela';
import { useMatch } from 'react-router-dom-v5-compat';

import config from '@/config';
import { useIsAdmin } from '@/modules/auth/hooks';

import { IgnoreSecurityAuditReportModal } from '../IgnoreSecurityAuditReportModal';
import { SecurityAuditAgeSecrets } from '../SecurityAuditAgeSecrets';
import { SecurityAuditLeaksSecrets } from '../SecurityAuditLeaksSecrets';
import { SecurityAuditLevelSecrets } from '../SecurityAuditLevelSecrets';
import { SecurityAuditReportOverview } from '../SecurityAuditReportOverview';
import { SecurityAuditReportSecrets } from '../SecurityAuditReportSecrets';
import { SecurityAuditSecretsTabs } from '../SecurityAuditSecretsTabs';
import * as felaRules from './SecurityAuditSecretsPage.rules';

export const SecurityAuditSecretsPage = () => {
    const isAdmin = useIsAdmin();
    const { css } = useFela({ isAdmin });

    const isReportPage = useMatch(config.routes.securityAudit);
    const isLevelPage = useMatch(config.routes.securityAuditLevel);
    const isAgePage = useMatch(config.routes.securityAuditAge);
    const isLeaksPage = useMatch(config.routes.securityAuditLeaks);

    return (
        <div className={css(felaRules.container)}>
            <SecurityAuditSecretsTabs />

            {isReportPage && (
                <>
                    <IgnoreSecurityAuditReportModal />
                    <SecurityAuditReportOverview />
                </>
            )}

            <div className={css(felaRules.listContainer)}>
                {isReportPage && <SecurityAuditReportSecrets />}
                {isLevelPage && <SecurityAuditLevelSecrets />}
                {isAgePage && <SecurityAuditAgeSecrets />}
                {isLeaksPage && <SecurityAuditLeaksSecrets />}
            </div>
        </div>
    );
};
